module.exports = __webpack_public_path__ + "img/DE04267.0723ace2.png";